import React, { useEffect } from "react";
import { insertRecoveryLostData } from "../../services/ConnectDataBase";
import { SCREEN_IDS } from "../FullComponent.js";

const RecoveryHandler = () => {
  useEffect(() => {
    const recoverAndSendData = async () => {
      // Recuperar los datos guardados en localStorage
      const savedData = JSON.parse(localStorage.getItem("currentCronometro"));
      if (savedData) {
        // console.log("Datos recuperados tras un fallo:", savedData);
        try {
          // Intentar enviar los datos al servidor
          const result = await insertRecoveryLostData(
            SCREEN_IDS.GENERAL,
            "inserRecoveryLostData",
            savedData
          );

          if (result) {
            // Si se procesaron correctamente o ya existen, eliminar del localStorage
            localStorage.removeItem("currentCronometro");
            console.log(
              "Datos procesados y eliminados del almacenamiento local."
            );
          } else {
            console.warn(
              "No se pudieron procesar los datos, se mantendrán en localStorage."
            );
          }
        } catch (error) {
          console.error("Error al enviar los datos recuperados:", error);
        }
      }
    };

    recoverAndSendData();
  }, []); // Solo se ejecuta al cargar el componente

  return null; // No renderiza nada
};

export default RecoveryHandler;
